import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { HttpService } from 'src/app/services/http-service.service';

const DEVICE_MOCKUP_SETTING_KEY = 'device_mockup_image';
const APP_STORE_URL_KEY = 'app_store_url';
const GOOGLE_PLAY_URL_KEY = 'google_play_url';
const DEFAULT_MOCKUP_IMAGE = './assets/img/mockup.png';

@Component({
  selector: 'divisas-capital-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss'],
})
export class DevicesComponent implements OnInit {
  deviceMockupImageUrl: string = DEFAULT_MOCKUP_IMAGE;
  appStoreUrl: string | null = null;
  googlePlayUrl: string | null = null;

  constructor(private readonly httpService: HttpService) {}

  ngOnInit(): void {
    forkJoin({
      mockup: this.httpService.getSettingByKey(DEVICE_MOCKUP_SETTING_KEY),
      appStore: this.httpService.getSettingByKey(APP_STORE_URL_KEY),
      googlePlay: this.httpService.getSettingByKey(GOOGLE_PLAY_URL_KEY),
    }).subscribe({
      next: ({ mockup, appStore, googlePlay }) => {
        if (mockup) {
          this.deviceMockupImageUrl = mockup;
        }
        if (appStore) {
          this.appStoreUrl = appStore;
        }
        if (googlePlay) {
          this.googlePlayUrl = googlePlay;
        }
      },
    });
  }
}
